import injectSheet from 'react-jss'
import SeatTradeModal from './SeatTradeModal'
import styles from './SeatTradeModal.styles'

export default injectSheet(styles)(SeatTradeModal)
